module.exports = __webpack_public_path__ + "img/hyundai-service.facc3748.png";